exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.box[data-v-70233663] {\n  background-color: #f3f3f3;\n}\n.small-list[data-v-70233663]{\n   padding: 5px 10px;\n}\n\n", ""]);

// exports
